import React from 'react';
import TravelPlanModal from '@/components/organisms/travel-plan-modal/travel-plan-modal';
import useQueryTravelPlan from '@/integrations/content/content-modules/travel-plan/travel-plan.hooks';
import { useHotelContext } from '@/libraries/contexts/hotel-context/hotel-context';
import { useSearchContext } from '@/libraries/contexts/search-context';

export interface TransportModeDetailsProps {
  /** An array of links to show */
  ctaLinks?: Content.Components['TravelPlanModuleHeadlessDto']['ctaLinks'];
  /** The text to show as a headline */
  headline?:
    | Content.Components['TravelPlanModuleHeadlessDto']['headline']
    | null;
  /** The UUID of the module */
  id: Content.Components['TravelPlanModuleHeadlessDto']['id'];
  /** The UUID of the current page */
  pageId: Content.Components['TravelPlanModuleHeadlessDto']['pageId'];
  /** The text to show as a sub headline */
  subHeadline?: Content.Components['TravelPlanModuleHeadlessDto']['subHeadline'];
  /** The text to show as a description */
  text?: Content.Components['TravelPlanModuleHeadlessDto']['text'];
}

const TransportModeDetails = ({
  ctaLinks = [],
  headline,
  id,
  pageId,
  subHeadline,
  text,
}: TransportModeDetailsProps) => {
  const { isOpenTravelPlan, parameters, setIsOpenTravelPlan } =
    useHotelContext();
  const { bonusCodes } = useSearchContext();
  const { data: dataTravelPlan, isFetching: isFetchingTravelPlan } =
    useQueryTravelPlan({
      parameters: parameters && {
        ...parameters,
        ...(parameters?.bonusCodes ? {} : bonusCodes ? { bonusCodes } : {}),
        id,
        pageId,
      },
    });

  if (!dataTravelPlan) return null;

  return (
    <TravelPlanModal
      ctaLinks={ctaLinks}
      headline={headline}
      isLoading={isFetchingTravelPlan}
      isOpen={isOpenTravelPlan}
      onClose={setIsOpenTravelPlan}
      subHeadline={subHeadline}
      text={text}
      travelPlan={dataTravelPlan.travelPlan}
    />
  );
};

TransportModeDetails.displayName = 'TransportModeDetails';

export default TransportModeDetails;
